<div [ngbTooltip]="toolTip" placement="left">
  <button
    [nf-button]="buttonVariant"
    [ngbPopover]="popover"
    placement="top-right"
    autoClose="true"
    triggers="contextmenu"
    (contextmenu)="$event.preventDefault()"
  >
    <span [ngClass]="iconClass"></span>
    <span class="ml-1">{{ numberOfAccountsWithoutOmega }}</span>
  </button>
</div>

<ng-template #popover>
  <button type="button" class="dropdown-item btn btn-link" (click)="onClick()">
    <span class="mdi mdi-filter"></span>
    <span class="ml-1">Filter Accounts</span>
  </button>
  <button
    type="button"
    class="dropdown-item btn btn-link"
    (click)="toggleConfigureModal()"
  >
    <span class="mdi mdi-cog-outline"></span>
    <span class="ml-1">Configure</span>
  </button>
</ng-template>
